import { render, staticRenderFns } from "./NewEmpApproval.vue?vue&type=template&id=19cb8a8e&scoped=true&"
import script from "./NewEmpApproval.vue?vue&type=script&lang=js&"
export * from "./NewEmpApproval.vue?vue&type=script&lang=js&"
import style0 from "./NewEmpApproval.vue?vue&type=style&index=0&id=19cb8a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb8a8e",
  null
  
)

export default component.exports